// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: "AIzaSyBCoQX8IZ5lI5y5X5of630JUjYEzB-AK2c",
	authDomain: "palma-apartman.firebaseapp.com",
	projectId: "palma-apartman",
	storageBucket: "palma-apartman.firebasestorage.app",
	messagingSenderId: "725362586060",
	appId: "1:725362586060:web:0acf8c9df3fca29ae02d69",
	measurementId: "G-2PW2SGG2EE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics };

